export const DEFAULT_BOARD_COLUMN_COLOR = '#7B61FF'

export const BOARD_COLUMN_TITLE_MAX_LENGTH = 255
